module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (_vm.dataShipment && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "status-content"
  }, [_c('div', {
    staticClass: "tag-content"
  }, [(_vm.dataShipment.attributes.status >= 1 && _vm.dataShipment.attributes.status <= 3) ? _c('span', {
    staticClass: "badge badge-primary badge-grabr"
  }, [_vm._v("Procesamiento en origen")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status >= 5 && _vm.dataShipment.attributes.status <= 7) ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-success"
  }, [_vm._v("Procesamiento en destino")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 4) ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-danger"
  }, [_vm._v("Stand-by")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 1) ? _c('p', [_vm._v("En direccion origen")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 2) ? _c('p', [_vm._v("Camino a aeropuerto")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 3) ? _c('p', [_vm._v("Vuelo al destino en curso")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 5) ? _c('p', [_vm._v("En aeropuerto del destino")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 6) ? _c('p', [_vm._v("En evaluación")]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 7) ? _c('p', [_vm._v("Evaluación finalizada")]) : _vm._e()]), _vm._v(" "), (_vm.dataShipment.attributes.status == 5 && _vm.$store.state.user.attributes.permissions_keys.includes(18)) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.dataOrderCopy != null && _vm.dataOrderCopy.length != 0) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.beginEvaluationPackages
    }
  }, [_vm._v("Iniciar evaluación de  paquetes")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 2) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(17)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showModalReprogramation
    }
  }, [_vm._v("Reprogramar")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(13)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmDepartureShipment
    }
  }, [_vm._v("Confirmar despegue")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dataShipment.attributes.status == 3) ? _c('div', {
    staticClass: "rr"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(16)) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmArrivalShipment
    }
  }, [_vm._v("Confirmar llegada")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Embarque # " + _vm._s(_vm.dataShipment.id))])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [(_vm.dataShipment) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.destination.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Operador de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.dataShipment.attributes.reciever_operator.attributes.username))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.departure_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de salida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.arrival_date)))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient2",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [(_vm.dataLuggageCopy.length > 0) ? _c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLuggageCopy), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)]) : _c('div', {
    staticClass: "vitrina"
  }, [_c('p', [_vm._v("No hay equipajes asignados")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient3",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [(_vm.dataOrderCopy.length > 0) ? _c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataOrderCopy), function(package) {
    return _c('li', [_c('cardPackage', {
      attrs: {
        "afterSavePackages": true,
        "dataPackage": package
      }
    })], 1)
  }), 0)]) : _c('div', {
    staticClass: "vitrina"
  }, [_c('p', [_vm._v("No hay paquetes asignados")])])])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReprogramation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalReprogramation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Reprogramación de embarque ")])]), _vm._v(" "), _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReprogramation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Nueva fecha de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateDeparture),
      expression: "newDateDeparture"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "name": "departure_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_date')),
      expression: "errors.has('departure_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva hora de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourDeparture),
      expression: "newHourDeparture"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "time",
      "name": "departure_hour"
    },
    domProps: {
      "value": (_vm.newHourDeparture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourDeparture = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('departure_hour')),
      expression: "errors.has('departure_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('departure_hour')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateArrival),
      expression: "newDateArrival"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "name": "arrival_date",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date')),
      expression: "errors.has('arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva hora de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newHourArrival),
      expression: "newHourArrival"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "time",
      "name": "arrival_hour"
    },
    domProps: {
      "value": (_vm.newHourArrival)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHourArrival = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_hour')),
      expression: "errors.has('arrival_hour')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrivaldeparture_hour')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reprogramateShipment
    }
  }, [_vm._v("Reprogramar embarque")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient2",
      "aria-expanded": "false",
      "aria-controls": "collapseclient2"
    }
  }, [_c('span', [_vm._v("Detalles de equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient3",
      "aria-expanded": "false",
      "aria-controls": "collapseclient3"
    }
  }, [_c('span', [_vm._v("Paquetes")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80dbf53c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shipment-show-view.vue
// module id = 1898
// module chunks = 1